import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export const ScrollableWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const ScrollableContent = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const FadeOverlay = styled.div<{ direction: string; visible: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50px;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    ${({ direction }) =>
      direction === 'left'
        ? 'to left, rgba(250,250,250, 0), rgba(250,250,250, 1)'
        : 'to right, rgba(250,250,250, 0), rgba(250,250,250, 1)'}
  );
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s;
  ${({ direction }) => (direction === 'left' ? 'left: 0;' : 'right: 0;')}
`;

const ScrollableFadeWrapper: FC = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isScrollableLeft, setIsScrollableLeft] = useState(false);
  const [isScrollableRight, setIsScrollableRight] = useState(false);

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;

    setIsScrollableLeft(scrollLeft > 0);
    setIsScrollableRight(
      Math.ceil(scrollLeft + clientWidth) < Math.floor(scrollWidth - 1)
    );
  };

  useEffect(() => {
    handleScroll();
    const container = containerRef.current;

    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <ScrollableWrapper>
      <FadeOverlay direction="left" visible={isScrollableLeft} />
      <FadeOverlay direction="right" visible={isScrollableRight} />
      <ScrollableContent ref={containerRef}>{children}</ScrollableContent>
    </ScrollableWrapper>
  );
};

export default ScrollableFadeWrapper;
